import React from 'react';
import Wrapper from './styles';
import Svg from '../../svg/Svg';
import UiButton from '../../ui/button/UiButton';

interface Props extends React.PropsWithChildren {
    isMenuVisible: boolean;
    onDrawerClick: (value: boolean) => void;
}

export default function SportMenuLabelV2({ children, isMenuVisible, onDrawerClick }: Props) {
    return (
        <Wrapper>
            {children}
            <UiButton
                size="small"
                color="ghost"
                icon={<Svg icon="drawer" rotate={isMenuVisible ? -90 : 90} />}
                onClick={() => onDrawerClick(!isMenuVisible)}
                className="menu-label-drawer"
            />
        </Wrapper>
    );
}
